import React from "react";
import usePeriods from "./usePeriods";
import usePeriodLevels from "./usePeriodLevels";
function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}
const useYearsLastPeriod = (activePeriod: string) => {
  const { data: levels } = usePeriodLevels();
  // const { data: periods } = usePeriods(periodLevel);

  const lastPeriod = React.useMemo(() => {
    if (levels) {
      const currentPeriod = levels
        .map((level) => {
          return level.periods.filter((p) => p.name === activePeriod).pop();
        })
        .filter(notEmpty)
        .pop();

      const periods = levels
        .filter((level) => level.id === currentPeriod?.periodlevel)
        .map((level) => level.periods)
        .filter(notEmpty)
        .pop();
      /*
        .map((level) => {
          return level.periods.filter((p) => p.periodlevel === currentPeriod?.periodlevel).pop();
        })
        .filter(notEmpty)
        .pop();        
      */
      if (currentPeriod && periods) {
        const yearOfCurrent = new Date(currentPeriod.startdate).getFullYear();
        return periods
          .filter((period) => {
            const yearOfPeriod = new Date(period.startdate).getFullYear();
            return yearOfPeriod === yearOfCurrent;
          })
          .sort((a, b) => {
            return a.startdate.localeCompare(b.startdate);
          })
          .pop();
      }
    }
    return null;
  }, [levels, activePeriod]);
  return lastPeriod;
};

export default useYearsLastPeriod;
